// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__1ZAnn","addBtnContainer":"AddDetails_addBtnContainer__rCxpU"};